import { Entity, FieldType, PersistenceType } from 'gossamer-unified';
import { Timetable } from './Timetable';

export interface TimetableConversationRow {
  id: number;
  timetable_id: number;
  role: 'user' | 'assistant';
  content: string;
  context: Record<string, any> | null;
  created_at: string;
}

export const TimetableConversation: Entity<TimetableConversationRow> = {
  id: 'TimetableConversation',
  title: 'Timetable Conversation',
  service: 'main',
  rowLabel: (row: TimetableConversationRow) => `${row.role}: ${row.content.substring(0, 50)}`,
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.timetable_conversation',
  },
  security: [{ role: 'staff', action: 'all', access: 'all' }],
  fields: {
    id: {
      seq: 5,
      type: FieldType.Integer,
      label: 'ID',
      persistence: PersistenceType.BackEndManaged,
      mandatory: true,
      autoIncrement: true,
    },
    timetable_id: {
      seq: 10,
      type: FieldType.Reference,
      label: 'Timetable',
      refEntity: Timetable,
      mandatory: true,
      listColumn: true,
    },
    role: {
      seq: 15,
      type: FieldType.Options,
      label: 'Role',
      options: [
        { id: 'user', label: 'User' },
        { id: 'assistant', label: 'Assistant' },
      ],
      mandatory: true,
      listColumn: true,
    },
    content: {
      seq: 20,
      type: FieldType.Text,
      label: 'Content',
      mandatory: true,
    },
    context: {
      seq: 25,
      type: FieldType.Object,
      label: 'Context',
    },
    created_at: {
      seq: 30,
      type: FieldType.Datetime,
      label: 'Created At',
      persistence: PersistenceType.BackEndManaged,
      listColumn: true,
    },
  },
};
